/* eslint-disable */
export enum CalendarViewType {
  DAY_GRID_MONTH = 'dayGridMonth',
  FIVE_DAYS_GRID = 'resourceTimeGridFiveDay',
  WEEK_GRID = 'resourceTimeGridWeek',
  EVENTS_LIST = 'listEvents',
  DAY_GRID = 'resourceTimeGridDay',
  NOTICE_BOARD = 'noticeBoard',
}
